import { useBricksPreloadedProps } from "hooks/useBrickStaticProps";
import dynamic from "next/dynamic";
import React from "react";
import { types, useAdminContext } from "react-bricks/frontend";
import styled from "styled-components";
import SpeakToTeam from "../../../components/pages/_jp/SpeakToTeam/index";

const items = {
  aboutUs: dynamic(() => import("../../../components/pages/_jp/AboutUs/AboutUs")),
  employeeApp: dynamic(() => import("../../../components/pages/_jp/EmployeeApp/index")),
  SpeakToTeam: dynamic(() => import("../../../components/pages/_jp/SpeakToTeam/index")),
  rewards: dynamic(() => import("../../../components/pages/_jp/Rewards/index")),
};

interface JapanPageProps {
  page: keyof typeof items;
}

const JapanPage: types.Brick<JapanPageProps> = ({ page }) => {
  const { strapiProps, rewardProps } = useBricksPreloadedProps();
  const { isAdmin } = useAdminContext();

  if (!page) {
    return null;
  }

  const Component = items[page];
  return (
    <Wrapper isAdmin={isAdmin}>
      <Component
        latestCaseStudy={strapiProps?.getCaseStudies?.latestCaseStudy}
        data={rewardProps?.regionalRewards}
        keyResources={strapiProps?.getBlogPosts?.posts}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div<{ isAdmin: boolean }>`
  div[class^="Page__NavContainer-"],
  footer {
    ${(props) => (props.isAdmin ? "display: none" : "")};
  }
`;

JapanPage.schema = {
  // Unique brick name
  name: "japan-page",
  label: "JapanPage",

  // Defaults when a new brick is added
  getDefaultProps: () => ({}),

  // Sidebar Edit controls for props
  sideEditProps: [
    {
      name: "page",
      label: "Page",
      type: types.SideEditPropType.Select,
      selectOptions: {
        display: types.OptionsDisplay.Select,
        options: Object.keys(items).map((value) => ({ value, label: value })),
      },
    },
  ],
};

export default JapanPage;
